import React, { useCallback, useMemo } from 'react';

import { useColumnControl, useControlRegistration } from '../ColumnControls/hooks';
import { VisibilityController, VisibilityControllerId, VisibilityControlProps } from './types';

const VisibilityControl: React.FunctionComponent<VisibilityControlProps> = (props) => {
  const { columnNames, state } = props;

  const { hasControl, updateColumn, getColumn } = useColumnControl(columnNames, state);

  const hide = useCallback(
    (name: string) => {
      if (hasControl(name)) {
        updateColumn({
          name,
          visible: false,
        });
      }
    },
    [hasControl, updateColumn]
  );

  const show = useCallback(
    (name: string) => {
      if (hasControl(name)) {
        updateColumn({
          name,
          visible: true,
        });
      }
    },
    [hasControl, updateColumn]
  );

  const isVisible = useCallback(
    (name: string): boolean => {
      return getColumn(name)?.visible ?? false;
    },
    [getColumn]
  );

  const control = useMemo(() => {
    const controller: VisibilityController = {
      id: VisibilityControllerId,
      handlers: { hide, show, isVisible },
      hasControl,
    };
    return controller;
  }, [hide, show, isVisible, hasControl]);

  useControlRegistration(control);

  const renderVisibilityControl = () => {
    return null;
  };

  return renderVisibilityControl();
};

export default VisibilityControl;
